import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';

const DEBOUNCE_DELAY = 300;

export const useSidebar = (setAlwaysOpen = false) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(setAlwaysOpen);

  const debounceOpen = useRef(
    debounce(() => {
      setIsSidebarOpen(true);
    }, DEBOUNCE_DELAY)
  ).current;

  const debounceClose = useRef(
    debounce(() => {
      setIsSidebarOpen(false);
    }, DEBOUNCE_DELAY)
  ).current;

  // cleanup on unmount
  useEffect(() => {
    return () => {
      debounceOpen.cancel();
      debounceClose.cancel();
    };
  }, [debounceOpen, debounceClose]);

  const onMouseEnterSidebar = useCallback(() => {
    debounceClose.cancel();
    debounceOpen();
  }, [debounceOpen, debounceClose]);

  const onMouseLeaveSidebar = useCallback(() => {
    debounceOpen.cancel();
    debounceClose();
  }, [debounceOpen, debounceClose]);

  return {
    isSidebarOpen,
    onMouseEnterSidebar,
    onMouseLeaveSidebar,
  };
};
